import type { Theme } from './types.js'

/** Construction Green — Identite WasteSite. Vert environnement + orange BTP + navy EU. */
export const constructionGreen: Theme = {
  id: 'construction-green',
  displayName: 'Construction Green',
  description: 'Vert environnement, accent orange chantier',
  preview: { primary: '#16a34a', sidebar: '#14291a', accent: '#ea580c' },
  tokens: {
    colors: {
      primary: '#16a34a',
      primaryHover: '#15803d',
      primaryLight: '#f0fdf4',
      secondary: '#1e3a5f',
      accent: '#ea580c',
      surface: '#ffffff',
      surfaceRaised: '#f5f5f4',
      background: '#fafaf9',
      border: '#d6d3d1',
      borderSubtle: '#e7e5e4',
      textPrimary: '#1c1917',
      textSecondary: '#57534e',
      textDisabled: '#a8a29e',
      textInverse: '#ffffff',
      success: '#059669',
      successLight: '#ecfdf5',
      warning: '#d97706',
      warningLight: '#fffbeb',
      error: '#dc2626',
      errorLight: '#fef2f2',
      info: '#2563eb',
      infoLight: '#eff6ff',
      sidebarBg: '#14291a',
      sidebarText: '#a8a29e',
      sidebarHover: 'rgba(22, 163, 74, 0.12)',
    },
  },
  darkMode: {
    colors: {
      surface: '#1a2e1f',
      surfaceRaised: '#0f1a12',
      background: '#080e0a',
      border: '#2d4a35',
      textPrimary: '#f5f5f4',
      textSecondary: '#a8a29e',
      sidebarBg: '#0a1a0e',
    },
  },
}
